import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: paginacaoListagem('id', 25, 'ASC'),
	idAtividade: {
		default: null,
		label: 'idAtividade',
		value: null,
	},
	idAtividadePedido: {
		default: null,
		label: 'idAtividadePedido',
		value: null,
	},
	informacoesPedido: {},
	numeroCasasDecimaisQtde: null,
	numeroCasasDecimaisValores: null,
	bpm: {
		hasAutority: false,
		etapaAtual: {
			atividadeNome: null,
			atividadeSituacao: null,
		},
	},
	idOrgao: {
		default: null,
		label: 'Orgão',
		value: null,
	},
	filtro: {
		atividadePedido: {
			default: null,
			label: 'Atividade Pedido',
			value: null,
		},
		numeroPedidoOuNumeroProcessoOuNumeroAta: {
			default: null,
			label: 'Pesquisa',
			value: null,
		},
		siglaOrgao: {
			default: null,
			label: 'Órgão',
			value: null,
		},
	},
	revisao: {},
}
